<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Enviar para assinar digitalmente</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div
								:class="{
									'form-group': true,
									'has-error': errors.has('whatsapp'),
								}"
							>
								<label for="whatsapp">Telefone (whatsapp)</label>
								<input
									ref="whatsapp"
									class="form-control"
									name="whatsapp"
									type="text"
									v-model="dados.whatsapp"
									v-validate="'required'"
									v-mask="['(##)####-####', '(##)#####-####']"
								/>
								<span v-show="errors.has('whatsapp')" class="help-block"
									>Campo obrigatório</span
								>
							</div>
						</div>
						<div class="col-md-12">
							<div
								:class="{
									'form-group': true,
									'has-error': errors.has('email'),
								}"
							>
								<label for="email">Email</label>
								<input
									class="form-control"
									name="email"
									type="text"
									v-model="dados.email"
									v-validate="'required'"
									ref="email"
								/>
								<span v-show="errors.has('email')" class="help-block"
									>Campo obrigatório</span
								>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="text-right" style="float: right">
						<button class="btn btn-default" @click="$emit('close')">
							<i class="fa fa-close"></i> Fechar
						</button>
						<button
							class="btn btn-primary"
							@click="enviar"
						>
							Enviar
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>

import { mask } from "vue-the-mask";

export default {
	directives: { mask },
	props: [],
	filters: {},
	data: () => ({
		dados: {
			whatsapp: '',
			email: '',
		},
	}),
	mounted() {
		this.$refs.whatsapp.focus();
	},
	methods: {
		enviar() {
			this.$emit('assinatura', this.dados.email, this.dados.whatsapp)
			this.dados = {
				whatsapp: '',
				email: ''
			}
		}
	},
	components: {},
};
</script>

<style scoped>
* {
	box-sizing: border-box;
}

.modal-mask {
	position: fixed;
	z-index: 1001;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	transition: opacity 0.3s ease;
}

.modal-container {
	width: 30%;
	height: auto;
	margin: 60px auto 0;
	padding: 10px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #333;
}

.modal-body {
	height: 250px;
	overflow-y: auto;
}

.text-right {
	text-align: right;
}

.form-label {
	display: block;
	margin-bottom: 1em;
}

.form-label > .form-control {
	margin-top: 0.5em;
}

.form-control {
	display: block;
	width: 100%;
	padding: 0.5em 1em;
	line-height: 1.5;
	border: 1px solid #ddd;
}

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.modal {
	display: block !important;
	/* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
	overflow-y: initial !important;
}

.modal-body {
	height: 250px;
	overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// modalAssinatura.vue?648f8657